import React from 'react';

/**
 * Shared content for Step 4 file upload List & Loop screens (#155514).
 */

// Accordion item for "How to prepare your files"
export const prepareFilesAccordionItem = (
  <va-accordion-item bordered header="How to prepare your files" level="3">
    <p>
      If your document is digital, make sure it’s one of the accepted file
      types.
    </p>
    <p>
      Before you upload your files, make sure they’re saved on the device you’re
      using to submit this claim. You can do this in 1 of 2 ways:
    </p>
    <ul>
      <li>
        On a computer connected to a scanner, scan each document and save the
        file as a PDF
      </li>
      <li>
        On a smartphone, take a photo of the document or use a scanning app to
        save it as a PDF
      </li>
    </ul>
  </va-accordion-item>
);

export const prepareFilesAccordion = (
  <va-accordion open-single>{prepareFilesAccordionItem}</va-accordion>
);
